import { task, timeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { macroCondition, isTesting } from '@embroider/macros';
import { A } from '@ember/array';
export default class StreamMonitor {
  /* These services the consuming apps. This architecture is a little silly */
  @service socket;
  @service profile;
  /* ---------------------------------------------------------------------- */

  @service stereo;
  @service store;

  @tracked cableUrl;
  @tracked stationUid;
  @tracked stationId;
  @tracked broadcastId;
  @tracked streamId;

  @tracked streamUrl;
  @tracked fallbackUrls;
  @tracked station;
  @tracked onUpdate;
  @tracked lastCacheKey;

  constructor({
    stationId,
    broadcastId,
    cableUrl,
    onUpdate = () => {},
  }) {
    this.stationId = stationId;
    this.broadcastId = broadcastId;
    this.cableUrl = cableUrl;
    this.onUpdate = onUpdate;
  }

  @task
  *start() {
    try {
      yield this.fetchNowPlayingData.perform();
      yield this.loadCable();
    } catch (e) {
      //no op
    }
    this.loop.perform();
  }

  @task
  *loop() { 
    if (macroCondition(isTesting())) {
      return;
    }
    while (true) {
      try {
        if (this.isLoaded && !this.cableConnection?.connected) {
          yield timeout(10000);
          yield this.fetchNowPlayingData.perform();
        } else if (this.isLoaded && this.cableConnection?.connected) {
          yield timeout(60000);
          yield this.fetchNowPlayingData.perform();
        } else {
          yield timeout(1000);
        }
      } catch (e) {
        //no op
        yield timeout(10000);
      }
    }
  }

  @task({ drop: true })
  *fetchNowPlayingData() {
    let nowPlaying = yield this.store.queryRecord('now-playing', {
        id: this.broadcastId,
        stationId: this.stationId,
        cache: new Date().getTime(),
      })
      .catch((e) => {
        console.error(e);
      });

    // this.streamsData = nowPlaying.streams;
    if (nowPlaying) {
      this.isLoaded = true;
      yield this.updateNowPlaying.perform(nowPlaying);
    }
  }

  loadCable() {
    this.cableConnection = this.socket.subscribe(
      {
        channel: 'NowPlayingChannel',
        station_id: this.stationId,
        broadcast_id: this.broadcastId,
      },
      {
        received: (data) => {
          if (this.profile?.features?.debugLogging) {
            console.log(
              '⚡️ received NowPlayingChannel update for stream monitor, handling...'
            );
          }
          this.lastCacheKey = data?.cache;
          this.fetchNowPlayingData.perform();
        },
      }
    );
  }

  @task
  *updateNowPlaying(nowPlaying) {
    let station = this.currentNowPlayingModel(nowPlaying, 'station')
    let broadcast = this.currentNowPlayingModel(nowPlaying, 'broadcast')
    let airing = this.currentNowPlayingModel(nowPlaying, 'airing')
    let show = this.currentNowPlayingModel(nowPlaying, 'show')
    let stream = this.currentNowPlayingModel(nowPlaying, 'stream')
    let track = this.currentNowPlayingModel(nowPlaying, 'track')
    let traffic = this.currentNowPlayingModel(nowPlaying, 'traffic')
    let note = this.currentNowPlayingModel(nowPlaying, 'note')

    this.streamUrl = stream?.allUrls;
    this.streamId = stream?.id;
    this.station = station;

    yield this.onUpdate(this.streamUrl, {
      nowPlaying,
      station,
      broadcast,
      airing,
      show,
      stream,
      track,
      traffic,
      note
    });
  }

  currentNowPlayingModel(nowPlayingRecord, modelName) {
    let id = nowPlayingRecord.belongsTo(modelName)?.id()

    if (id) {
      return this.store.peekRecord(modelName, id)
    }
  }
}
